module.exports = __webpack_public_path__ + "static/media/tribe-acad-student.fe696e4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/common/tribe-acad-student.png
// module id = 187
// module chunks = 147